import { gql, useMutation } from "@apollo/client";
import { errorFragment } from "../../../../../../../gql/GqlErrorFragment";
import {
  DeleteRouteAgreementMutation,
  DeleteRouteAgreementMutationVariables,
} from "@/gql/graphql";

const query = gql`
  ${errorFragment}
  mutation DeleteRouteAgreement($routeAgreementId: ID!, $rowVersion: String!) {
    productPrice {
      routeAgreement {
        deleteRouteAgreement(
          routeAgreementId: $routeAgreementId
          rowVersion: $rowVersion
        ) {
          ... on ErrorResult {
            ...ErrorFragment
          }
          ... on DeleteRouteAgreementSuccessResult {
            success
          }
        }
      }
    }
  }
`;

export const useDeleteRouteAgreementMutation = () =>
  useMutation<
    DeleteRouteAgreementMutation,
    DeleteRouteAgreementMutationVariables
  >(query, { refetchQueries: ["HeadAgreement"] });
